<template lang="pug">
  .component-driver-card
    .action-bar
      .title
        h2 Driver cards
      .action
        i.fa.fa-plus-circle.fa-2x(data-toggle="create-card")

    .cards.tabs-inner-content
      #create-card.is-hidden(data-toggler="is-hidden", v-f="")
        h3 select an unassigned card
        selectize-card(:nullDriver="true" @optionSelected="selectUnassignedCard")
        .row
          .columns.text-center
            button.button(type="button", v-if="selectedUnassignedCard !== null", @click="assignCard") assign to driver
        h3 create a new card
        create-card(:driver_id="$route.params.id" @addCard="addCard")

      base-list(:component="component", :dataLoader="dataLoader" ref="list")

</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import Card from "components/backoffice/Card";
  import CreateCard from "components/structure/ui/CreateCard";
  import BaseList from "../../../pages/backoffice/BaseList";
  import SelectizeCard from "../../structure/ui/lists/selectize/SelectizeCard";
  import MaggieHelper from "../../../maggieHelper";

  export default {
    name: "DriverCards",
    components: {
      SelectizeCard,
      BaseList,
      CreateCard,
      Card,
    },
    data() {
      return {
        headers: ['Card name & ID', 'Driver', 'Chip id', 'Active'],
        component: require('components/backoffice/Card'),
        selectedUnassignedCard: null
      }
    },
    created() {
    },
    methods: {
      addCard(event) {
        if(event === 'added') {
          this.$refs.list.loadData(1)
        }
      },
      selectUnassignedCard(card) {
        this.selectedUnassignedCard = card
      },
      assignCard() {
        const item = this.selectedUnassignedCard
        if (item) {
          item.driver_id = this.$route.params.id
          KeplerBackofficeSdk.cards.select(item.id).edit(item, () => {
            MaggieHelper.notification('edit-esit', 'Card bound successfully');
            this.$refs.list.loadData(1)
          })
        }
      },
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.drivers.list(page, resultsPerPage, {id: this.$route.params.id}).cards((data) => {
          callback(data)
        })
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  //.driver-licenses
    margin: 10px
  .component-driver-card
    #create-card
      border: 1px solid #e6e6e6
      background: #fefefe
      padding: 1em 1em 0
      margin-bottom: 2em
      border-radius: 4px
</style>



// WEBPACK FOOTER //
// DriverCards.vue?70248c44